import jwtDecode from 'jwt-decode';
export function decodeToken(token) {
  if (!token) {
    return null;
  }
  try {
    return jwtDecode(token);
  } catch (error) {
    console.log(`An error occured: ${error}.`);
    return null;
  }
}
//# sourceMappingURL=decodeToken.js.map